import { useQuery } from '@tanstack/react-query';

import { roleTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getRoles: roleTypes.GetRoles = () => {
  return axios.get('/roles');
};

type QueryFnType = typeof getRoles;

type UseGetRolesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetRoles = ({ config = {} }: UseGetRolesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['roles'],
    queryFn: getRoles,
  });
};
